import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import * as React from 'react';

type ExpandedClickableIconProps = {
  icon: JSX.Element;
} & React.ComponentPropsWithoutRef<'div'>;

const ExpandedClickableIcon = React.forwardRef<HTMLDivElement, ExpandedClickableIconProps>(
  ({icon, className, ...props}: ExpandedClickableIconProps, ref): JSX.Element => (
    <div ref={ref} className={classNames(css(styles.icon), className)} {...props}>
      {icon}
    </div>
  )
);

ExpandedClickableIcon.displayName = 'ExpandedClickableIcon';

export default ExpandedClickableIcon;

const styles = StyleSheet.create({
  icon: {
    cursor: 'pointer',
    minHeight: '27px',
    minWidth: '27px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
